module.exports = __webpack_public_path__ + "static/media/1.7_manual.d581f5dc.png";